import { useCallback, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";

import JourneySidebar from "@/components/journey/JourneySidebar";
import JourneyTopbar from "@/components/journey/JourneyTopbar";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { API } from "@/lib/api";
import { readToken, clearToken } from "@/lib/tokenStore";

export default function JourneyLayout() {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [healthOk, setHealthOk] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const token = readToken();
    if (!token) return undefined;
    axios
      .get(`${API}/admin/crm/health`, {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 15000,
      })
      .then((r) => {
        if (!cancelled) setHealthOk(Boolean(r?.data?.ok));
      })
      .catch(() => {
        if (!cancelled) setHealthOk(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleLogout = useCallback(async () => {
    const token = readToken();
    try {
      if (token) {
        await axios.post(`${API}/admin/logout`, null, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch {
      /* server may already be gone; ignore */
    }
    clearToken();
    toast.success("Abgemeldet");
    navigate("/admin", { replace: true });
  }, [navigate]);

  return (
    <div className="flex min-h-screen bg-[#050607] text-zinc-100">
      <div className="hidden lg:flex">
        <JourneySidebar />
      </div>

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent
          side="left"
          className="w-64 border-r border-white/5 bg-[#050607] p-0"
        >
          <JourneySidebar onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex min-h-screen flex-1 flex-col">
        <JourneyTopbar
          onLogout={handleLogout}
          onOpenMobileNav={() => setMobileOpen(true)}
        />
        <main
          data-testid="journey-main"
          data-health={healthOk === null ? "pending" : healthOk ? "ok" : "fail"}
          className="flex-1 px-4 py-6 md:px-8 md:py-10"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
